import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { ChangeDetectorRef, Component, ElementRef, TemplateRef } from '@angular/core';
import {
  EmptyCV,
  fileTypeExtention,
  obligationSelect,
} from './../../../../core/models/messages';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ISort, translations } from './../../../../core/models/call-offer';
import { serverError } from './../../../../core/models/messages';
import { EsnConsultantService } from './../../../../core/services/esn-consultant/esn-consultant.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, State } from 'country-state-city';
import {
  headerColumns,
  statusCandidate,
} from './../../../../core/models/candidat';
import {
  linkedInRegExp,
  patternEmail,
  patternNumbersOnly,
  patternfirstName,
  patternfirstNamechiffre,
} from './../../../../core/models/pattern';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import * as JSZip from 'jszip';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { ExportService } from '@shared/services/export.service';
import { PageEvent } from '@angular/material/paginator';
import { ConsultantSelectedService } from '@core/services/esn-consultant/consultant-selected.service';
@Component({
  selector: 'app-list-consultant',
  templateUrl: './list-consultant.component.html',
  styleUrls: ['./list-consultant.component.css'],
})
export class ListConsultantComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  freeSearch: boolean = false;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  loadSpinner: boolean = false;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listconsultant: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  statut = statusCandidate;
  candidat_id: any;
  company_name: any;
  fileName: string = '';
  fileError: string = '';
  fileExtention: string = '';
  file: any = '';
  stateList: any = [];
  showResetButtons: boolean = true;
  isvalid: boolean = false;
  isexistemail = false;
  isCollapsed = true;
  cvName: any;
  fileBulkError: any;
  showResetButton: boolean = true;
  isLoadSpinner: boolean = true;
  iscv:boolean=false

  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns;
  typeintervenant: any;
  newHeader!: { checked: boolean; name: string; code: string }[];
  displayedColumns: string[] = [
    'select',
    'ID_user',
    'image_url',
    'first_name',
    'phone_number',
    'updated_at',
    'email',
    'city',
    'years_of_experience',
    'CV',
    'score',
    'status',
    'actions',
  ];
  contratRequest = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  selectedconsultant: any;
  clientId2_name:any;
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  id: any;
  isButtonDisabled: boolean = false;
  pagination : boolean =false;

  errorMessage: string = '';
  errorMessageprofil: string = '';

  consultantId: any;
  modalRef?: BsModalRef;
  name: any;
  cv: any;
  salary: any;
  idcon!: number;
  countries: any = [];
  consultantExist: boolean = true;
  cv_file!: string;
  Candidate_info: any;
  findisabled:any;
  listclient: { id: number; name: string }[] = [];
  clientList : any[] = [];
  listmanager: {
    uuid: string; id: number; full_name: string, first_name: string, last_name: string 
}[] = [];
  manager: any[] = [];
  dataHeader: any = [];
  listNames: string[] = [];
  mobilities: any[] = [];
  isMissionEnded = false;
  formconsultant: FormGroup = this.createconsultantForm();
  addBulk!: FormGroup;
  selectedFile: File | null = null;
  client: any[] = [];
  skillsList: { name_FR: string }[] = [];
  first_name: any;
  last_name: any;
  linkedin: any;
  currentSortColumn: string = 'name'; // Initial column to sort by
  clientSelected: boolean = false;
  ischecked = true;
  selectedCandidats: any = [];
  fileExtentions: string = '';
  private unsubscribeAll: Subject<void> = new Subject();
  data: any[] = [
    {
      competences: [
        'nom',
        'prenom',
        'pays',
        'num',
        'email',
        'email_pro',
        'poste',
        'diplomes',
        'certificats',
        'mois_premiere_experience',
        'annee_premiere_experience',
        'client',
        'site_web_client',
        'linkedin_client',
        'date_debut_mission',
        'date_fin_mission',
        'mois_signature_contrat',
        'annee_signature_contrat',
        'salaire',
        'tjm_achat',
        'tjm_vente',
        'linkedin',
        'cv',
        'photo',
        'competences',
      ],
    },
  ];

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private esnconsultantservice: EsnConsultantService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private modalService: BsModalService,
    private candidatservice: EsnCandidatService,
    private router: Router,
    private appeloffreservice: EsnAppeloffreService,
    private cdRef: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private exportService: ExportService,
    private consultantSelectedService : ConsultantSelectedService
  ) {}
  ngOnInit() {
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.searchForm.patchValue({ client_final_name: null });
    this.countries = Country.getAllCountries();
    this.getListclient();
    //this.getListmanager();
    this.getListconsultant();
    this.getListSkills();
    this.getListElementHeader();
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
    this.isButtonDisabled = false;
    this.formconsultant = this.formBuilder.group(
      {
        candidate_id: [''],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        emailProESN: ['', [Validators.email, Validators.pattern(patternEmail)]],
        linkedin_link: ['',Validators.pattern(linkedInRegExp)],
        cv: [''],
        desired_workstation: [''],
        date_signature_contrat: [''],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
        salary: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_achat: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_vente: ['', [Validators.pattern(patternNumbersOnly)]],
        manager_id: [''],
        client_id: [''],
      },
      { validators: this.dateRangeValidator }
    );

    this.formconsultant = this.createconsultantForm();
    this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
      this.clientSelected = !!value;
      if (!this.clientSelected) {
        this.formconsultant.get('mission_start_date')?.disable();
        this.formconsultant.get('mission_end_date')?.disable();
      } else {
        this.formconsultant.get('mission_start_date')?.enable();
        this.formconsultant.get('mission_end_date')?.enable();
      }
    });
    this.formconsultant.get('linkedin_link')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });

  this.formconsultant.get('cv')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });
  this.setValidatorRequirements();

  const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  openModalBulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formconsultant.get('open_for_mission')?.setValue(1);
    this.fileExtentions = '';
  }
  /*download file add bulk */
  downloadCsv() {
    this.esnconsultantservice.downloadcsvfileAddBulkConsultant().subscribe({
      next: (res: Blob) => {
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'ajout en masse esn consultant.csv');
      },
      error: (err) => {
        // Handle the error appropriately
      },
    });
  }

  formAddBulk() {
    this.addBulk = this.formBuilder.group({
      file: [null, [Validators.required]],
    });
  }
  fileErr: boolean = false;
  /*select file and add Bulk Candidates */
  onFileSelected(event: any) {
    this.fileErr = false;
    this.fileExtentions = '';
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      const fileExtension = this.selectedFile.name
        .toLowerCase()
        .substr(this.selectedFile.name.lastIndexOf('.'));
      const allowedExtensions = ['.csv', '.xlsx', '.xls'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtentions = fileTypeExtention;
        this.fileErr = true;
      }
    }
  }

  addBulkCandidates() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      this.spinner.show();
      this.esnconsultantservice.addBulkCandidates(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();

          this.fileBulkError = res.export_file;
          this.getbulkCandidate(this.fileBulkError);
          this.toastrService.success('Fichier importé avec succès');
          this.closeModal();
          this.selectedFile = null;
          this.reset()
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error?.message) {
              if (err.error.message === 'File contains only headers.') {
                this.toastrService.error('Le fichier est vide');
              } else if (
                err.error.message ===
                'File headers do not match the expected headers.'
              ) {
                this.toastrService.error(
                  'Les en-têtes de fichiers ne correspondent pas aux en-têtes attendus.'
                );
              } else {
                this.toastrService.error(serverError);
              }
            } else {
              this.toastrService.error(serverError);
            }
            this.closeModal();
            this.selectedFile = null;
          }
        },
      });
    }
  }
  getbulkCandidate(file: File) {
    let exportSuccess = false;
    this.esnconsultantservice.getbulkCandidate(file).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], { type: 'application/octet-stream' });
        saveAs(blob, this.fileBulkError);
        exportSuccess = true;
        if (exportSuccess) {
          this.toastrService.success(
            'Résultat de fichier importé a été exporté avec succès'
          );
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastrService.error(serverError);
      },
    });
  }
  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appeloffreservice
        .getHeaderElements(15)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.esnconsultantservice
        .listPageconsultantActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  changeSelectionElement(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.appeloffreservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.esnconsultantservice
        .changeSubPageStateconsultantIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }

  //ADD
  dateRangeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const startDate = control.get('mission_start_date')!.value;
    const endDate = control.get('mission_end_date')!.value;

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeInvalid: true };
    }

    return null;
  }

  //ADD
  createconsultantForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [
          data?.first_name || '',
          [Validators.required, Validators.pattern(patternfirstNamechiffre)],
        ],
        last_name: [
          data?.last_name || '',
          [Validators.required, Validators.pattern(patternfirstNamechiffre)],
        ],
        emailProESN: [
          data?.emailProESN || '',
          [Validators.pattern(patternEmail)],
        ],
        email: [
          data?.email || '',
          [Validators.required, Validators.pattern(patternEmail)],
        ],
        linkedin_link: [data?.linkedin_link || ''],
        cv: [data?.cv || ''],
        desired_workstation: [data?.desired_workstation || ''],
        date_signature_contrat: [data?.date_signature_contrat || ''],
        salary: [data?.salary || null],
        tjm_achat: [data?.tjm_achat || ''],
        tjm_vente: [data?.tjm_vente || ''],
        manager_id: [data?.manager_id || null],
        client_id: [data?.client_id?data?.client_id:data?.client_id2 || null],
        candidate_id: [data?.candidate_id || ''],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
        mobility: [data?.mobility || []],
        desired_contract: [data?.desired_contract || []],
        softSkills: [data?.softSkills || []],
        destination_country: [data?.destination_country || []],
        contract_type: [data?.contract_type || []],
        skills_text: [data?.skills_text || []],
      },
      { validator: this.dateRangeValidator }
    );
  }

  setValidatorRequirements() {

    const linkedinControl = this.formconsultant.get('linkedin_link');
    const cvControl = this.formconsultant.get('cv');

    // Effacer les validateurs existants
    linkedinControl?.clearValidators();
    cvControl?.clearValidators();

    if (!linkedinControl?.value && !cvControl?.value) {
      linkedinControl?.setValidators([
        Validators.pattern(linkedInRegExp),
      ]);
    } else {
      if (linkedinControl?.value) {
        linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
      }
      if (cvControl?.value) {
        cvControl?.clearValidators();
        // linkedinControl?.clearValidators();
      }
    }

    linkedinControl?.updateValueAndValidity({ emitEvent: false });
    cvControl?.updateValueAndValidity({ emitEvent: false });
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            // .split('/')[1]
            candidat.file_test = candidat.file_test;
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  disableLink(event: Event) {
    if (this.listconsultant.clientId2_name === null) {
      event.preventDefault();
    }
  }

  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip');
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }

  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }

  getListclient() {
    this.esnconsultantservice.getclient().subscribe({
      next: (response) => {
        if (response.data) {
          this.listclient = response.data;
          this.client = response.data;
          this.clientList = this.client.map(item=> item.name);
        }
      },
      error: (error) => {
      },
    });
  }

  //ADD
  // getListmanager() {
  //   this.esnconsultantservice.getmanagernew().subscribe({
  //     next: (response) => {
  //       if (response.data) {
  //         this.listmanager = response.data.map((el: any) => {
  //           return {
  //             ...el,
  //             full_name: `${el.first_name} ${el.last_name}`
  //           };
  //         });
  //       }
  //     },
  //     error: (error) => {
  //     },
  //   });
  // }
  clearFile() {
    this.file = null;
    this.fileName = '';
    this.formconsultant.get('cv')?.setValue('');
  }

  //ADD
  // createconsultant() {
  //   this.formconsultant.markAllAsTouched();
  //   this.formconsultant.markAsDirty();
  //   this.setValidatorRequirements();

  //   if (!this.isexistemail) {

  //     let fromdata = new FormData();
  //     fromdata.append('first_name', this.formconsultant.value.first_name);
  //     fromdata.append('last_name', this.formconsultant.value.last_name);
  //     fromdata.append('email', this.formconsultant.value.email);
  //     if (this.formconsultant.value.emailProESN) {
  //       fromdata.append('emailProESN', this.formconsultant.value.emailProESN);
  //     }
  //     if(this.formconsultant.value.date_signature_contrat)
  //     {
  //       fromdata.append('date_signature_contrat', this.formconsultant.value.date_signature_contrat);
  //     }
  //     if(this.formconsultant.value.linkedin_link){
  //     fromdata.append('linkedin_link', this.formconsultant.value.linkedin_link)
  //     };
  //     if( this.formconsultant.value.desired_workstation)
  //     {
  //       fromdata.append('desired_workstation',this.formconsultant.value.desired_workstation );
  //     }
  //     if (this.formconsultant.value.tjm_achat) {
  //       fromdata.append('tjm_achat', this.formconsultant.value.tjm_achat);
  //     }
  //     if (this.formconsultant.value.tjm_vente) {
  //       fromdata.append('tjm_vente', this.formconsultant.value.tjm_vente);
  //     }
  //     if (this.formconsultant.value.salary) {
  //       fromdata.append('salary', this.formconsultant.value.salary);
  //     }
  //     if (this.formconsultant.value.manager_id) {
  //       fromdata.append('manager_id', this.formconsultant.value.manager_id);
  //     }
  //     if (this.formconsultant.value.client_id) {
  //       fromdata.append('client_id', this.formconsultant.value.client_id);
  //     } 
  //     if (this.file) {
  //       fromdata.append('cv', this.file);
  //     } 

  //     if (this.formconsultant.invalid) {
  //       return;
  //     }
  //     this.enableFormFields();
  //     this.esnconsultantservice.createconsultant(fromdata).subscribe({
  //       next: (response) => {
  //         this.toastrService.success('consultant a été ajouté avec succès');
  //         this.navigateToProfile(response.data?.user_id);

  //         this.getListconsultant();
  //         this.close_modal_add();
  //       },
  //       error: (error: any) => {
  //         if (error?.status === 404) {
  //           this.toastrService.error('Utilisateur associé à une autre ESN.');
  //         } else if (error.error.message && typeof error.error.message === 'string') {
  //           this.toastrService.error(error.error.message);
  //         } else if (error?.error && error?.error?.data) {
  //           if (
  //             error.error.data.email &&
  //             error.error.data.email[0] === 'The email has already been taken.'
  //           ) {
  //             this.toastrService.error("L'email est déjà utilisé.");
  //           } else if (
  //             error.error.data.linkedin_link &&
  //             error.error.data.linkedin_link[0] ===
  //               'The linkedin link must be a valid URL.'
  //           ) {
  //             this.toastrService.error(
  //               'Le lien LinkedIn doit être une URL valide.'
  //             );
  //           } else if (
  //             error.error.data.cv &&
  //             error.error.data.cv[0] === 'The cv field is required.'
  //           ) {
  //             this.toastrService.error('Le CV est requis.');
  //           } else if (
  //             error.error.data.linkedin_link &&
  //             error.error.data.linkedin_link[0] ===
  //               'The linkedin link has already been taken.'
  //           ) {
  //             this.toastrService.error('LinkedIn est déjà utilisé.');
  //           } else  if (error.status === 403 && error.error.message) {
  //             this.toastrService.error(error.error.message);
  //         } else {
  //           this.toastrService.error("Une erreur inattendue s'est produite.");
  //         }
  //         }}

  //     });
  //   }
  //   else {
  //     if (this.company_name == null) {
  //       let data = {
  //         candidate_id: this.candidat_id,
  //         salary: this.formconsultant.value.salary,

  //         tjm_achat: this.formconsultant.value.tjm_achat,
  //         tjm_vente: this.formconsultant.value.tjm_vente,
  //         emailProESN: this.formconsultant.value.emailProESN,
  //         mission_start_date: this.formconsultant.value.mission_start_date,
  //         mission_end_date: this.formconsultant.value.mission_end_date,
  //         manager_id: this.formconsultant.value.manager_id
  //           ? this.formconsultant.value.manager_id
  //           : '',
  //         client_id: this.formconsultant.value.client_id
  //           ? this.formconsultant.value.client_id
  //           : '',
  //         date_signature_contrat:
  //           this.formconsultant.value.date_signature_contrat,
  //         desired_workstation: this.formconsultant.value.desired_workstation,
  //       };
  //       this.disableFormFields();
  //       this.esnconsultantservice.createconsultant(data).subscribe({
  //         next: (response) => {
  //           this.toastrService.success('consultant a été ajouté avec succès ');

  //           this.getListconsultant();

  //           this.close_modal_add();
  //         },
  //         error: (error: any) => {
  //           if (error?.status === 404) {
  //             this.toastrService.error('Utilisateur associé à une autre ESN.');
  //           } else if (error?.error && error?.error?.data) {
  //             if (
  //               error.error.data.email &&
  //               error.error.data.email[0] ===
  //                 'The email has already been taken.'
  //             ) {
  //               this.toastrService.error("L'email est déjà utilisé.");
  //             } else if (
  //               error.error.data.linkedin_link &&
  //               error.error.data.linkedin_link[0] ===
  //                 'The linkedin link must be a valid URL.'
  //             ) {
  //               this.toastrService.error(
  //                 'Le lien LinkedIn doit être une URL valide.'
  //               );
  //             } else if (
  //               error.error.data.cv &&
  //               error.error.data.cv[0] === 'The cv field is required.'
  //             ) {
  //               this.toastrService.error('Le CV est requis.');
  //             } else if (
  //               error.error.data.linkedin_link &&
  //               error.error.data.linkedin_link[0] ===
  //                 'The linkedin link has already been taken.'
  //             ) {
  //               this.toastrService.error("L'linkedin est déjà utilisé.");
  //             }
  //             else if (
  //               error.error && error.error.message ==='candidate was already a salary'
  //             ) {
  //               this.toastrService.error("La candidate est déjà salariée.");
  //             }else {
  //               this.toastrService.error(
  //                 "Une erreur inattendue s'est produite."
  //               );
  //             }
  //           } else {
  //             this.toastrService.error("Une erreur inattendue s'est produite.");
  //           }
  //         },
  //       });
  //     } else {
  //       let data = {
  //         candidate_id: this.candidat_id,
  //         salary: this.formconsultant.value.salary,
  //         tjm_achat: this.formconsultant.value.tjm_achat,
  //         tjm_vente: this.formconsultant.value.tjm_vente,

  //         emailProESN: this.formconsultant.value.emailProESN,
  //         mission_start_date: this.formconsultant.value.mission_start_date,
  //         mission_end_date: this.formconsultant.value.mission_end_date,
  //         manager_id: this.formconsultant.value.manager_id
  //           ? this.formconsultant.value.manager_id
  //           : '',
  //         client_id: this.formconsultant.value.client_id
  //           ? this.formconsultant.value.client_id
  //           : '',
  //         date_signature_contrat:
  //           this.formconsultant.value.date_signature_contrat,
  //       };
  //       this.disableFormFields();
  //       this.esnconsultantservice.createconsultant(data).subscribe({
  //         next: (response) => {
  //           this.toastrService.success('consultant a été ajouté avec succès ');

  //           this.getListconsultant();

  //           this.close_modal_add();
  //         },
  //         error: (error: any) => {
  //           this.toastrService.error(`Une erreur inattendue s'est produite. ${error.error.message}`);
  //           if (error?.status === 404) {
  //             this.toastrService.error('Utilisateur associé à une autre ESN.');
  //           } else if (error?.error && error?.error?.data) {
  //             if (
  //               error.error.data.email &&
  //               error.error.data.email[0] ===
  //                 'The email has already been taken.'
  //             ) {
  //               this.toastrService.error("L'email est déjà utilisé.");
  //             } else if (
  //               error.error.data.linkedin_link &&
  //               error.error.data.linkedin_link[0] ===
  //                 'The linkedin link must be a valid URL.'
  //             ) {
  //               this.toastrService.error(
  //                 'Le lien LinkedIn doit être une URL valide.'
  //               );
  //             } else if (
  //               error.error.data.cv &&
  //               error.error.data.cv[0] === 'The cv field is required.'
  //             ) {
  //               this.toastrService.error('Le CV est requis.');
  //             } else if (
  //               error.error.data.linkedin_link &&
  //               error.error.data.linkedin_link[0] ===
  //                 'The linkedin link has already been taken.'
  //             ) {
  //               this.toastrService.error("L'linkedin est déjà utilisé.");
  //             } else {
  //               this.toastrService.error(
  //                 "Une erreur inattendue s'est produite."
  //               );
  //             }
  //           } else {
  //             this.toastrService.error("Une erreur inattendue s'est produite.");
  //           }
  //         },
  //       });
  //     }
  //   }
  // }
  navigateToProfile(consultantUuid: any) {
    this.router.navigate([
      '/candidats/profilecandidatesn',
      consultantUuid,
    ]);
  }

  /* set validation for multiple form control */
  setValidations(name: string) {
    this.formconsultant.get(name)?.setValidators(Validators.required);
    this.formconsultant.get(name)!.updateValueAndValidity();
  }
  /* clearValidators */
  clearValidators(name: string) {
    this.formconsultant.get(name)?.clearValidators();
    this.formconsultant.get(name)?.updateValueAndValidity();
  }

  getclientName(manager_id: string): string {
    const manager = this.listmanager.find(
      (manager) => manager.uuid == manager_id
    );
    return manager ? manager.first_name : 'client not found';
  }

  //ADD
  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf', '.docx', '.doc'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));

      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
    }
    this.formconsultant.get('cv')?.setValue(this.file);
  }

  isFileNameCompatible(): boolean {
    if (!this.file) {
      return false;
    }

    const allowedExtensions = ['.pdf', '.docx', '.doc'];
    const fileExtension = this.file.name
      .toLowerCase()
      .substr(this.file.name.lastIndexOf('.'));
    return allowedExtensions.includes(fileExtension);
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchconsultantesn();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListconsultant();
      }
    }
  }
   onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.searchForm.dirty && this.btnSearchactive) {
        this.searchconsultantesn(0);
        
      } 
      // if (this.freeSearchForm.dirty && this.btnSearchactive) {
      //   this.searchconsultantesn();
      // } 
      else {
        this.getListconsultant();
      }
    }
  getListconsultant(sort?: ISort) {
    this.spinner.show();
    let dataPyload = {
            per_page: this.pageSize,
            page: this.currentPage,
        };

    this.esnconsultantservice.getListconsultant(dataPyload).subscribe({
      next: (response: any) => {
        this.spinner.hide();
        if (response.data && response.data.data) {
          this.listconsultant = response.data.data
          this.formconsultant
            .get('salary')
            ?.setValue(this.listconsultant.consultant_e_s_n_s_Salary);
          this.clientId2_name=response.data.data.clientId2_name
          this.totalItems = response.data.total;

        }
      },
      error: (error: any) => {
        if (error.error.message) {
          this.toastrService.error(error.error.message);
        }
        this.spinner.hide();
      },
    });
  }
  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      post: ['', data?.post],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      manager_name: ['', data?.manager_name],
      client_final_name: ['', data?.client_final_name?data?.client_final_name:data?.clientId2_name],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm_vente: ['', data?.tjm_vente],
      tjm_vente_range: ['', data?.tjm_vente_range],
      tjm_achat: ['', data?.tjm_achat],
      tjm_achat_range: ['', data?.tjm_achat_range],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      mobility: [[], data?.mobility],
      country: [[], data?.country],
      contract_type: [[], data?.country],
      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }

  reset() {
    this.stateList=[];
    this.currentPage=0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchForm.patchValue({ client_final_name: null });
    this.getListconsultant();
  }
  changeSelection(event: any, data: any) {
    data.checked = event.target.checked;
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  /* search */
  searchconsultantesn(pageNumber : number = this.currentPage) {
    this.btnSearchactive = true;

    
    let data: { [key: string]: any } = {
      per_page: this.pageSize,
      page: this.currentPage,
    };

    if (this.freeSearch) {
      const searchValue = this.freeSearchForm.get('search')?.value;
      data = {
        ...data,
        search: this.transformSearch(searchValue),
      };
    } else {
          let valueForm = this.searchForm.value;
          valueForm.desired_salary_range = this.convertKToNumber(
            valueForm.desired_salary_range?.toString()
          );

      data = {
        ...data,
        name: valueForm?.name ?? null,
        post: valueForm?.post ?? null,
        skillsOr: valueForm?.skillsOr ?? [],
        skillsAnd: valueForm?.skillsAnd ?? [],
        manager_name: valueForm?.manager_name ?? null,
        client_final_name: valueForm?.client_final_name ?? null,
        tjm_achat: valueForm?.tjm_achat ?? null,
        tjm_achat_range: valueForm?.tjm_achat_range ?? null,
        tjm_vente: valueForm?.tjm_vente ?? null,
        tjm_vente_range: valueForm?.tjm_vente_range ?? null,
        desired_salary: this.searchForm.value?.desired_salary ?? null,
        desired_salary_range: this.searchForm.value?.desired_salary_range ?? null,
        max_experience_years: valueForm?.max_experience_years ?? null,
        min_experience_years: valueForm?.min_experience_years ?? null,
        mobility: valueForm?.mobility ?? [],
        country: valueForm?.country ?? [],
      };
    }
    
    this.spinner.show();
    this.esnconsultantservice
      .searchconsultant(data)
      .subscribe({
        next: (resSearch) => {
            this.listconsultant = resSearch.data.data;
            this.totalItems = resSearch.data.total;
            this.spinner.hide();
        },
        error: (error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
      this.searchForm = this.createSearchForm();
      this.searchForm.reset();
      this.getListconsultant();
   }
   else {
    //  this.freeSearchForm.reset();
    //  this.freeSearchForm = this.createFreeSearchForm();
     this.getListconsultant();
   }
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('mobility')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('mobility')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('destination_country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('mobility')?.disable();
      mode == 'add';
      this.searchForm.get('destination_country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('mobility')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  ////////////////////////////////////////////////////////////////////////////////////
  transformSearch(search: string): string {
    search = search.replace(/\|\|/g, ' OR ');
    search = search.replace(/&&/g, ' AND ');
    search = search.replace(/!/g, ' NOT ');

    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    search = search.replace(/\s+/g, ' ');

    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  // //ADD
  // getconsultantByEmail(event: any) {
  //   this.errorMessage = '';
  //   //this.formconsultant.reset();
  //   const enteredEmail = event.target.value.trim();

  //   if (enteredEmail === '') {
  //     this.enableFormFields();
  //     this.formconsultant.get('linkedin_link')?.enable();
  //     this.selectedconsultant = '';
  //     this.formconsultant.patchValue({
  //       first_name: '',
  //       last_name: '',
  //       linkedin_link: '',
  //       cvName: '',
  //       desired_workstation: '',
  //     });
  //     this.isexistemail = false;
  //     this.isButtonDisabled = false;
  //     this.errorMessage = '';
  //     return;
  //   }

  //   this.esnconsultantservice
  //     .getconsultantbyemail(enteredEmail)
  //     .subscribe({
  //       next: (res: any) => {
  //         if (res.status === 200) {
  //           this.isexistemail = true;
  //           if(res.data.cv && res.data.cv!=='null'){
  //             this.iscv=true
  //            }
  //            else{
  //             this.iscv=false
  //            }

  //           this.formconsultant.get('linkedin_link')?.enable();
  //           this.company_name = res.company_name;
  //           this.selectedconsultant = res.data.cv;
  //           this.candidat_id = res.data.uuid;
  //           if (enteredEmail !== res.data.email) {
  //             this.formconsultant.get('linkedin_link')?.enable();
  //             this.formconsultant.patchValue({
  //               first_name: '',
  //               last_name: '',
  //               selectedconsultant: '',
  //               desired_workstation: '',
  //             });
  //             this.isexistemail = false;
  //             this.isButtonDisabled = false;
  //             this.errorMessage = '';
  //             return;
  //           }

  //           this.formconsultant.patchValue({
  //             email: res.data.email,
  //             first_name: res.data.first_name,
  //             last_name: res.data.last_name,
  //             linkedin_link: res.data.linkedin_link,
  //             cv: res.data.cv,
  //             desired_workstation: res.data.desired_workstation,
  //             client_name: res.client_name,
  //           });
  //           if (res.data.cv) {
  //             this.file = { name: res.data.cv };
  //           }

  //           this.errorMessage = '';
  //           this.isButtonDisabled = false;

  //           if (
  //             res.data.linkedin_link !== null &&
  //             res.data.linkedin_link !== ''
  //           ) {
  //             this.formconsultant.get('linkedin_link')?.disable();
  //           } else {
  //             this.formconsultant.get('linkedin_link')?.enable();
  //           }

  //           this.disableFormFields();
  //         } else {
  //           this.isexistemail = true;

  //           this.isButtonDisabled = true;
  //           this.errorMessage = '"Utilisateur associé à une autre ESN."';
  //         }
  //       },
  //       error: (error: any) => {
  //         this.isexistemail = false;
  //         this.iscv=false
  //         this.enableFormFields()
  //         this.formconsultant.patchValue({
  //           first_name: '',
  //           last_name: '',
  //           selectedconsultant: '',
  //           desired_workstation: '',
  //           cv:'',
  //           linkedin_link:'',
  //         });
  //         if (
  //           error?.error?.message === 'User already associated with this ESN'
  //         ) {
  //           this.isexistemail = true;
  //           this.isButtonDisabled = true;
  //           this.errorMessage = '"Utilisateur associé à cet ESN."';
  //         }
  //         if (error?.error?.message === 'User associated with another ESN') {
  //           this.isexistemail = true;
  //           this.isButtonDisabled = true;
  //           this.errorMessage = '"Utilisateur associé à une autre ESN."';
  //         }
  //         if (error?.error?.message === 'User profile was not completed') {
  //           this.isexistemail = true;
  //           this.isButtonDisabled = true;
  //           this.errorMessageprofil = '"Le profil utilisateur n\'a pas été complété"';
  //         }
  //       },
  //     });
  //   if (
  //     this.formconsultant.value.linkedin_link === undefined &&
  //     this.formconsultant.value.cv === undefined &&
  //     this.formconsultant.value.cv !== null &&
  //     this.formconsultant.value.linkedin_link !== null
  //   ) {
  //     this.isvalid = true;
  //   } else {
  //     this.isvalid = false;
  //   }
  // }

  //ADD
  // resetCV() {
  //   const inputFile = document.getElementById('cv') as HTMLInputElement;
  //   if (inputFile) {
  //     inputFile.value = '';
  //     this.fileExtention = '';
  //     this.fileError = '';
  //     this.isvalid = true;
  //   }
  //   this.fileName = '';
  //   this.showResetButtons = true;
  // }
  // //ADD
  // disableFormFields() {
  //   if (this.formconsultant) {
  //     this.formconsultant.get('first_name')?.disable();
  //     this.formconsultant.get('last_name')?.disable();
  //   }
  // }
  // //ADD
  // enableFormFields() {
  //   if (this.formconsultant) {
  //     this.formconsultant.get('first_name')?.enable();
  //     this.formconsultant.get('last_name')?.enable();
  //     this.formconsultant.get('emailProESN')?.enable();
  //     this.formconsultant.get('linkedin_link')?.enable();
  //     this.formconsultant.get('desired_workstation')?.enable();
  //     this.formconsultant.get('cv')?.enable();
  //   }
  // }

  closeModal() {
    this.formconsultant.reset();
    this.selectedconsultant = '';
    this.cvName = '';
    this.isButtonDisabled = false;
    this.errorMessage = '';
    this.modalRef!.hide();
  }
  // close_modal_add() {
  //   this.formconsultant.reset();
  //   this.formconsultant.get('email')?.setValue('');
  //   this.isButtonDisabled = false;

  //   this.selectedconsultant = '';
  //   this.cdRef.detectChanges();
  //   let btnClose = document.getElementById('ModalClose_add_consultant');
  //   if (btnClose) {
  //     btnClose.click();
  //     this.formconsultant.reset();
  //     this.cvName = '';
  //     this.errorMessage = '';
  //     this.selectedconsultant = '';
  //     this.cdRef.detectChanges();
  //   }

  //   this.enableFormFields();
  //   this.isButtonDisabled = false;
  //   this.errorMessage = '';
  //   this.selectedconsultant = '';
  //   this.showResetButtons = false;
  //   if (this.modalRef && typeof this.modalRef.hide === 'function') {
  //     this.modalRef.hide();
  //   }
  //   this.iscv=false
  // }

  resetform() {
    this.formconsultant.reset();
    this.cvName = '';
  }
  isnull: boolean = false;
  testclient:boolean=false;
  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    if (data.cv === 'null') {
      this.isnull = true;
    } else {
      this.isnull = false;
    }
   if(data.client_id){
    this.testclient=true
   }
   else{
    this.testclient=false
   }
    this.formconsultant.get('email')?.setValue('');
    this.formconsultant = this.createconsultantForm(data);
    const salary = this.formconsultant.get('salary');
    if (salary && data && data.consultant_e_s_n_s_Salary) {
      salary.setValue(data.consultant_e_s_n_s_Salary);
    }
    const tjm_achat = this.formconsultant.get('tjm_achat');
    if (tjm_achat && data && data.consultant_e_s_n_s_Tjm_achat) {
      tjm_achat.setValue(data.consultant_e_s_n_s_Tjm_achat);
    }
    const tjm_vente = this.formconsultant.get('tjm_vente');
    if (tjm_vente && data && data.consultant_e_s_n_s_Tjm_vente) {
      tjm_vente.setValue(data.consultant_e_s_n_s_Tjm_vente);
    }
    this.formconsultant.get('client_id')?.setValue(data.client_id?data.client_id:data.client_id2);
    // this.formconsultant.get('manager_id')?.setValue(data.manager_id);


    if (this.listmanager.length > 0) {
      const manager = this.listmanager.filter( el => el.uuid == data.manager_id);
      if (manager) {
        this.formconsultant.get('manager_id')?.setValue(manager[0]?.uuid);        
      }
    }


    this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
      this.clientSelected = !!value;
      if (!this.clientSelected) {
        this.formconsultant.get('mission_start_date')?.disable();
        this.formconsultant.get('mission_end_date')?.disable();
      } else {
        this.formconsultant.get('mission_start_date')?.enable();
        this.formconsultant.get('mission_end_date')?.enable();
      }
    });

    this.formconsultant.get('linkedin_link')?.enable();

    this.formconsultant.get('mission_start_date')?.enable();
    this.formconsultant.get('mission_end_date')?.enable();
    this.formconsultant
      .get('date_signature_contrat')
      ?.setValue(new Date(data.consultant_e_s_n[0].date_signature_contrat));
    this.formconsultant
      .get('mission_start_date')
      ?.setValue(new Date(data.consultant_e_s_n_Mission_start_date));
    this.formconsultant
      .get('mission_end_date')
      ?.setValue(new Date(data.consultant_e_s_n_Mission_end_date));
      
    this.formconsultant.get('candidate_id')?.setValue(data.uuid);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  openModaladd(template: TemplateRef<any>, data?: any, mode?: string) {
    this.formconsultant.reset();
    this.formconsultant.get('email')?.setValue('');
    this.selectedconsultant = '';
    this.errorMessage = '';

    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }


  // //UPDATE
  // updateConsultant(event: Event) {
  //   event.preventDefault();
  //   const updatedValues: any = {};

  //   // Convertir les valeurs en chaînes, y compris pour les valeurs nulles
  //   updatedValues.tjm_vente = this.formconsultant.value.tjm_vente ? this.formconsultant.value.tjm_vente.toString() : '';
  //   updatedValues.tjm_achat = this.formconsultant.value.tjm_achat ? this.formconsultant.value.tjm_achat.toString() : '';
  //   updatedValues.salary = this.formconsultant.value.salary ? this.formconsultant.value.salary.toString() : '';

  //   // Patcher le formulaire avec les valeurs mises à jour
  //   this.formconsultant.patchValue(updatedValues);

  //   // Ne pas supprimer les clés, mais laisser les valeurs vides si null ou "null"
  //   const cleanedValues = Object.entries(this.formconsultant.value)
  //     .reduce((acc: any, [key, value]) => {
  //       acc[key] = value !== null && value !== 'null' ? value : '';
  //       return acc;
  //     }, {});


  //     if(this.file){
  //       cleanedValues.cv = this.file
  //     }
  //     const formData = new FormData();
  //     Object.entries(cleanedValues).forEach(([key, value]) => {
  //     if (key === 'cv' && value instanceof Blob) {
  //       formData.append(key, value);
  //     } else {
  //       formData.append(key, String(value ?? ''));
  //     }
  //   })

  //   this.esnconsultantservice
  //     .updateConsultant(
  //       cleanedValues.candidate_id,
  //       formData
  //     )
  //     .subscribe((res: any) => {
  //       this.toastrService.success('Consultant a été modifié avec succès');
  //       this.closeModal();
  //       this.getListconsultant();

  //     }, (error: any) => {
  //       const message = error?.error?.message || 'Une erreur inattendue s\'est produite.';
  //       this.toastrService.error(message);
  //     })
  // }

  finmission(uuid: any) {
    if (this.isMissionEnded) return;

    Swal.fire({
      title: 'Confirmez-vous la fin de mission pour ce consultant ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.esnconsultantservice.finmission(uuid).subscribe({
          next: (response: any) => {
            if (response.data) {
              this.toastrService.success('Fin mission avec succès.');
              this.getListconsultant();
              this.isMissionEnded = true;
            }
          },
          error: (error: any) => {
          },
        });
      }
    });
  }

  dissocierconsultant(uuid: any) {
    let formdata = new FormData();
    formdata.append('candidate_id', uuid);
    Swal.fire({
      title: 'Voulez-vous vraiment dissocier ce consultant ? <br> La dissociation entraîne le verrouillage des CRA pour le mois en cours.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.esnconsultantservice
          .dissocierconsultant(formdata)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              this.toastrService.success('Vous avez dissocié ce consultant avec succès.');

              this.searchconsultantesn();
            },
            error: (error) => {
              this.spinner.hide();
              if(error.error.message && error.error.message!=='This user has associated workflows and cannot be processed.'){
                this.toastrService.error(error.error.message);
              }
              else if (error.error.status===400 && error.error.message && error.error.message === 'This user has associated workflows and cannot be processed.' ) {
                this.toastrService.error('Impossible de dissocier cet utilisateur en raison des workflows associés.');
              }
              else {
                this.toastrService.error(serverError);
              }
            },
          });
      }
    });
  }

  /* go to suggestion job offer */
  navigateToSuggestionJobOffer(id: number) {
    this.router.navigate([
      '/consultants/suggestion-jobOffer',
      { id: id },
    ]);
  }

  /* go to suggestion job request */
  navigateToSuggestionJobRequest(id: number) {
    this.router.navigate([
      '/consultants/suggestion-jobRequest',
      { id: id },
    ]);
  }

  redirectToLinkedIn(linkedinLink: string): void {
    window.open(linkedinLink, '_blank');
  }
  isDateRangeValid(): boolean {
    return !this.formconsultant.hasError('dateRangeInvalid');
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  // @TOFIX : duplicated
  /**
   * Returns a string list of contract types for tooltip display based on contract type codes.
   * @param contractTypes - An array of contract type codes.
   * @returns A string listing the contract type names.
   */
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    return Object.keys(contractTypes).map(type => contractMap[type.toString()] || '').join(', ');
  }

  // @TOFIX : duplicated
   /**
   * Returns a string list of skills for tooltip display.
   * @param contractTypes - An array of skills.
   * @returns A string listing the skills names.
   */
   getSkillsList(skillsList: string[]): string {
    if(Array.isArray(skillsList))  return skillsList.map(skill => skill).join(', ');
    else return ''
  }

  // @TOFIX: duplicated
/**
* Exports the CV of a candidate based on the specified type and company ID.
*
* @param {any} candidate - The selected candidate
* @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
* @param {number | null} idCompany - The ID of the company for which the CV is being exported.
*                          Use `null` if no specific company is associated.
*/
exportCVCandidate( candidat: any, type: number, idCompany : number | null) {
  this.spinner.show();
  const candidate = {
    ids: [candidat.uuid],
    last_name: candidat?.last_name,
    first_name: candidat?.first_name
  } 
  const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
  }

  updateNavigation(consultant: any) {
    this.consultantSelectedService.setConsultantSelected(consultant);
    this.router.navigate(['/consultants/modification-consultant/']);
  }
}
